// extracted by mini-css-extract-plugin
module.exports =  {"mpv-config-container":"mpv-config-container-WD3hH","mpv-config-control":"mpv-config-control-qUflm"};